<template>
  <div v-if="visible" class="tab-vessel-eq">
    <tab-vessel-eq-UICustom-layout :element-blocks="elementBlocks">
      <el-form-item v-if="elementDict.voyageFlight.viewable" slot="voyageFlight" class="warn-label">
        <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
        <el-input v-model="form.voyageFlight" no="6" disabled />
      </el-form-item>
      <el-form-item v-if="elementDict.mbl.viewable" slot="mbl">
        <line-label slot="label" :class="elementDict.mbl.isRequire ? 'blue' : ''" :label="elementDict.mbl.label" />
        <div style="display: flex;flex-direction: row;padding-right: 3px;">
          <el-input v-show="isInputMbl" v-model="form.mbl" no="7" disabled :class="form.mbl==='CANCELLED'?'mbl-red':''" />
          <el-input v-show="!isInputMbl" v-model="form.mbl" no="8" disabled :class="form.mbl==='CANCELLED'?'mbl-red':''" @input="mblConfig.curRule = null" />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.jobSoNo.viewable" slot="jobSoNo">
        <line-label slot="label" :class="elementDict.jobSoNo.isRequire ? 'blue' : ''" :label="elementDict.jobSoNo.label" />
        <so-no-input v-model="form.jobSoNo" no="27" :disabled="!isEdit || !elementDict.jobSoNo.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingDate.viewable" slot="bookingDate" class="warn-label">
        <line-label slot="label" :class="elementDict.bookingDate.isRequire ? 'blue' : ''" :label="elementDict.bookingDate.label" />
        <el-date-picker
          ref="bookingDate"
          v-model="form.bookingDate"
          no="bookingDate"
          :disabled="!isEdit || !elementDict.bookingDate.writable"
          type="date"
          style="width:100%;"
          clearable
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          @blur="()=> { handleBlur('bookingDate', null, true, true, form) }"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingNo.viewable" slot="bookingNo">
        <line-label slot="label" :class="elementDict.bookingNo.isRequire ? 'blue' : ''" :label="elementDict.bookingNo.label" />
        <el-input v-model="form.bookingNo" :disabled="!isEdit || !elementDict.bookingNo.writable" no="9" />
      </el-form-item>
      <el-form-item v-if="elementDict.quotationNum.viewable" slot="quotationNum">
        <line-label slot="label" :class="elementDict.quotationNum.isRequire ? 'blue' : ''" :label="elementDict.quotationNum.label" />
        <el-input v-model="form.quotationNum" :disabled="!isEdit || !elementDict.quotationNum.writable" no="12" />
      </el-form-item>
      <!-- 机场 -->
      <el-form-item v-if="elementDict.airport.viewable" slot="airport">
        <line-label slot="label" :class="elementDict.airport.isRequire ? 'blue' : ''" :label="elementDict.airport.label" />
        <el-input
          v-model="form.airport"
          no="19"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.airport.writable"
        />
      </el-form-item>
      <!-- 实际进场时间 -->
      <el-form-item v-if="elementDict.actualEntryTime.viewable" slot="actualEntryTime" class="warn-label">
        <line-label slot="label" :class="elementDict.actualEntryTime.isRequire ? 'blue' : ''" :label="elementDict.actualEntryTime.label" />
        <el-date-picker
          ref="actualEntryTime"
          v-model="form.actualEntryTime"
          no="20"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.actualEntryTime.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('actualEntryTime', null, true, true, form) }"
        />
      </el-form-item>
      <!-- 实际配载时间 -->
      <el-form-item v-if="elementDict.actualLoadingTime.viewable" slot="actualLoadingTime" class="warn-label">
        <line-label slot="label" :class="elementDict.actualLoadingTime.isRequire ? 'blue' : ''" :label="elementDict.actualLoadingTime.label" />
        <el-date-picker
          ref="actualLoadingTime"
          v-model="form.actualLoadingTime"
          no="21"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.actualLoadingTime.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('actualLoadingTime', null, true, true, form) }"
        />
      </el-form-item>
      <!-- 预计起飞时间 -->
      <el-form-item v-if="elementDict.estimatedDepartureTime.viewable" slot="estimatedDepartureTime" class="warn-label">
        <line-label slot="label" :class="elementDict.estimatedDepartureTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedDepartureTime.label" />
        <el-date-picker
          ref="estimatedDepartureTime"
          v-model="form.estimatedDepartureTime"
          no="22"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.estimatedDepartureTime.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('estimatedDepartureTime', null, true, true, form) }"
        />
      </el-form-item>
      <!-- 实际起飞时间 -->
      <el-form-item v-if="elementDict.actualDepartureTime.viewable" slot="actualDepartureTime" class="warn-label">
        <line-label slot="label" :class="elementDict.actualDepartureTime.isRequire ? 'blue' : ''" :label="elementDict.actualDepartureTime.label" />
        <el-date-picker
          ref="actualDepartureTime"
          v-model="form.actualDepartureTime"
          no="23"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.actualDepartureTime.writable"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('actualDepartureTime', null, true, true, form) }"
        />
      </el-form-item>
      <!-- 预计抵达时间 -->
      <el-form-item v-show="elementDict.estimatedArrivalTime.viewable && showButton" slot="estimatedArrivalTime" class="warn-label">
        <line-label slot="label" :class="elementDict.estimatedArrivalTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedArrivalTime.label" />
        <el-date-picker
          ref="estimatedArrivalTime"
          v-model="form.estimatedArrivalTime"
          no="estimatedPortDischargeTime"
          type="datetime"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.estimatedArrivalTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('estimatedArrivalTime', null, true, true, form) }"
        />
      </el-form-item>
      <!-- 实际抵达时间 -->
      <el-form-item v-show="elementDict.actualArrivalTime.viewable && showButton" slot="actualArrivalTime" class="warn-label">
        <line-label slot="label" :class="elementDict.actualArrivalTime.isRequire ? 'blue' : ''" :label="elementDict.actualArrivalTime.label" />
        <el-date-picker
          ref="actualArrivalTime"
          v-model="form.actualArrivalTime"
          no="34"
          type="datetime"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.actualArrivalTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('actualArrivalTime', null, true, true, form) }"
        />
      </el-form-item>
      <!-- 实际收单时间 -->
      <el-form-item v-show="elementDict.actualReceivingTime.viewable && showButton" slot="actualReceivingTime" class="warn-label">
        <line-label slot="label" :class="elementDict.actualReceivingTime.isRequire ? 'blue' : ''" :label="elementDict.actualReceivingTime.label" />
        <el-date-picker
          ref="actualReceivingTime"
          v-model="form.actualReceivingTime"
          no="actualReceivingTime"
          type="datetime"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.actualReceivingTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('actualReceivingTime', null, true, true, form) }"
        />
      </el-form-item>
      <!-- 实际卸货时间 -->
      <el-form-item v-show="elementDict.actualUnloadingTime.viewable && showButton" slot="actualUnloadingTime" class="warn-label">
        <line-label slot="label" :class="elementDict.actualUnloadingTime.isRequire ? 'blue' : ''" :label="elementDict.actualUnloadingTime.label" />
        <el-date-picker
          ref="actualUnloadingTime"
          v-model="form.actualUnloadingTime"
          no="35"
          type="datetime"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.actualUnloadingTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('actualUnloadingTime', null, true, true, form) }"
        />
      </el-form-item>
      <!-- 实际到货通知时间 -->
      <el-form-item v-show="elementDict.actualArrivalNotificationTime.viewable && showButton" slot="actualArrivalNotificationTime" class="warn-label">
        <line-label slot="label" :class="elementDict.actualArrivalNotificationTime.isRequire ? 'blue' : ''" :label="elementDict.actualArrivalNotificationTime.label" />
        <el-date-picker
          ref="actualArrivalNotificationTime"
          v-model="form.actualArrivalNotificationTime"
          no="actualArrivalNotificationTime"
          type="datetime"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.actualArrivalNotificationTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('actualArrivalNotificationTime', null, true, true, form) }"
        />
      </el-form-item>
      <!-- 实际提货时间 -->
      <el-form-item v-show="elementDict.actualPickupTime.viewable && showButton" slot="actualPickupTime" class="warn-label">
        <line-label slot="label" :class="elementDict.actualPickupTime.isRequire ? 'blue' : ''" :label="elementDict.actualPickupTime.label" />
        <el-date-picker
          ref="actualPickupTime"
          v-model="form.actualPickupTime"
          no="36"
          type="datetime"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.actualPickupTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('actualPickupTime', null, true, true, form) }"
        />
      </el-form-item>
      </el-form>
      <el-form-item v-show="elementDict.estimatedWarehouseDeliveryTime.viewable && showButton" slot="estimatedWarehouseDeliveryTime" :title="elementDict.estimatedWarehouseDeliveryTime.label">
        <line-label slot="label" :class="elementDict.estimatedWarehouseDeliveryTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedWarehouseDeliveryTime.label" />
        <el-date-picker
          ref="estimatedWarehouseDeliveryTime"
          v-model="form.estimatedWarehouseDeliveryTime"
          :disabled="!isEdit || !elementDict.estimatedWarehouseDeliveryTime.writable"
          no="41"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('estimatedWarehouseDeliveryTime', null, true, true, form) }"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.actualWarehouseDeliveryTime.viewable && showButton" slot="actualWarehouseDeliveryTime" :title="elementDict.actualWarehouseDeliveryTime.label">
        <line-label slot="label" :class="elementDict.actualWarehouseDeliveryTime.isRequire ? 'blue' : ''" :label="elementDict.actualWarehouseDeliveryTime.label" />
        <el-date-picker
          ref="actualWarehouseDeliveryTime"
          v-model="form.actualWarehouseDeliveryTime"
          :disabled="!isEdit || !elementDict.actualWarehouseDeliveryTime.writable"
          no="42"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('actualWarehouseDeliveryTime', null, true, true, form) }"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.estimatedShippingTime.viewable && showButton" slot="estimatedShippingTime" :title="elementDict.estimatedShippingTime.label">
        <line-label slot="label" :class="elementDict.estimatedShippingTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedShippingTime.label" />
        <el-date-picker
          ref="estimatedShippingTime"
          v-model="form.estimatedShippingTime"
          :disabled="!isEdit || !elementDict.estimatedShippingTime.writable"
          no="43"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('estimatedShippingTime', null, true, true, form) }"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.actualShippingTime.viewable && showButton" slot="actualShippingTime" :title="elementDict.actualShippingTime.label">
        <line-label slot="label" :class="elementDict.actualShippingTime.isRequire ? 'blue' : ''" :label="elementDict.actualShippingTime.label" />
        <el-date-picker
          ref="actualShippingTime"
          v-model="form.actualShippingTime"
          :disabled="!isEdit || !elementDict.actualShippingTime.writable"
          no="44"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('actualShippingTime', null, true, true, form) }"
        />
      </el-form-item>
      <!-- 预计送达时间 -->
      <el-form-item v-show="elementDict.estimatedTimeOfDelivery.viewable && showButton" slot="estimatedTimeOfDelivery">
        <line-label slot="label" :class="elementDict.estimatedTimeOfDelivery.isRequire ? 'blue' : ''" :label="elementDict.estimatedTimeOfDelivery.label" />
        <el-date-picker
          ref="estimatedTimeOfDelivery"
          v-model="form.estimatedTimeOfDelivery"
          no="32"
          type="datetime"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.estimatedTimeOfDelivery.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('estimatedTimeOfDelivery', null, true, true, form) }"
        />
      </el-form-item>
      <!-- 实际送达时间 -->
      <el-form-item v-if="elementDict.actualDeliveryTime.viewable && showButton" slot="actualDeliveryTime">
        <line-label slot="label" :class="elementDict.actualDeliveryTime.isRequire ? 'blue' : ''" :label="elementDict.actualDeliveryTime.label" />
        <el-date-picker
          ref="actualDeliveryTime"
          v-model="form.actualDeliveryTime"
          no="33"
          type="datetime"
          :disabled="!isEdit || Boolean(form.lclMasterUuid) || !elementDict.actualDeliveryTime.writable"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
          @blur="()=> { handleBlur('actualDeliveryTime', null, true, true, form) }"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.shippingAddress.viewable" slot="shippingAddress">
        <line-label slot="label" :class="elementDict.shippingAddress.isRequire ? 'blue' : ''" :label="elementDict.shippingAddress.label" />
        <el-input
          v-model="form.shippingAddress"
          :disabled="!isEdit || !elementDict.shippingAddress.writable"
          type="textarea"
          :rows="3"
          no="49"
          @dblclick.native="showAdvanceTextDialog(elementDict.shippingAddress.label,form.shippingAddress,val=>{form.shippingAddress=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.shippingContactPerson.viewable" slot="shippingContactPerson">
        <line-label slot="label" :class="elementDict.shippingContactPerson.isRequire ? 'blue' : ''" :label="elementDict.shippingContactPerson.label" />
        <el-input v-model="form.shippingContactPerson" :disabled="!isEdit || !elementDict.shippingContactPerson.writable" no="50" />
      </el-form-item>
      <el-form-item v-if="elementDict.shippingContactInfo.viewable" slot="shippingContactInfo">
        <line-label slot="label" :class="elementDict.shippingContactInfo.isRequire ? 'blue' : ''" :label="elementDict.shippingContactInfo.label" />
        <el-input v-model="form.shippingContactInfo" :disabled="!isEdit || !elementDict.shippingContactInfo.writable" no="51" />
      </el-form-item>
      <el-form-item v-if="elementDict.fileCutoff.viewable" slot="fileCutoff">
        <line-label slot="label" :class="elementDict.fileCutoff.isRequire ? 'blue' : ''" :label="elementDict.fileCutoff.label" />
        <el-date-picker
          ref="fileCutoff"
          v-model="form.fileCutoff"
          :disabled="!isEdit || !elementDict.fileCutoff.writable"
          no="52"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm"
          style="width: 100%"
          @blur="()=> { handleBlur('fileCutoff', null, true, true, form) }"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customerFileCutoff.viewable" slot="customerFileCutoff">
        <line-label slot="label" :class="elementDict.customerFileCutoff.isRequire ? 'blue' : ''" :label="elementDict.customerFileCutoff.label" />
        <el-date-picker
          v-model="form.customerFileCutoff"
          :disabled="!isEdit || !elementDict.customerFileCutoff.writable"
          no="56"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customCutoff.viewable" slot="customCutoff">
        <line-label slot="label" :class="elementDict.customCutoff.isRequire ? 'blue' : ''" :label="elementDict.customCutoff.label" />
        <el-date-picker
          v-model="form.customCutoff"
          :disabled="!isEdit || !elementDict.customCutoff.writable"
          no="54"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customerCutoff.viewable" slot="customerCutoff">
        <line-label slot="label" :class="elementDict.customerCutoff.isRequire ? 'blue' : ''" :label="elementDict.customerCutoff.label" />
        <el-date-picker
          v-model="form.customerCutoff"
          :disabled="!isEdit || !elementDict.customerCutoff.writable"
          no="55"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customerShutout.viewable" slot="customerShutout">
        <line-label slot="label" :class="elementDict.customerShutout.isRequire ? 'blue' : ''" :label="elementDict.customerShutout.label" />
        <el-date-picker
          v-model="form.customerShutout"
          :disabled="!isEdit || !elementDict.customerShutout.writable"
          no="56"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
        />
      </el-form-item>
      </el-form>
      <el-form-item v-if="elementDict.secondFlight.viewable" slot="secondFlight" class="warn-label">
        <line-label slot="label" :class="elementDict.secondFlight.isRequire ? 'blue' : ''" :label="elementDict.secondFlight.label" />
        <el-input v-model="form.secondFlight" disabled no="64" />
      </el-form-item>
      <!-- 起运港 -->
      <el-form-item v-show="elementDict.secondPolCode.viewable" slot="secondPolCode" class="warn-label">
        <line-label slot="label" :class="elementDict.secondPolCode.isRequire ? 'blue' : ''" :label="elementDict.secondPolCode.label" />
        <cargo-advance-select
          ref="secondPolCode"
          no="secondPolCode"
          :select-type="selectTypeNames.basic_data_Airport"
          :disabled="!isEdit || !elementDict.secondPolCode.writable"
          filterable
          :default-value="form.secondPolCode"
          tag-name="code"
          style="flex:1"
          @parentCallBack="p=>{form.secondPolCode=p.value;form.secondPol=p.englishName;}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.secondPol.viewable" slot="secondPol" class="warn-label">
        <line-label slot="label" :class="elementDict.secondPol.isRequire ? 'blue' : ''" :label="elementDict.secondPol.label" />
        <el-input v-model="form.secondPol" :disabled="!isEdit || !elementDict.secondPol.writable" no="secondPol" />
      </el-form-item>
      <!-- 二程目的港(代码) -->
      <el-form-item v-show="elementDict.secondPodCode.viewable" slot="secondPodCode" class="warn-label">
        <line-label slot="label" :class="elementDict.secondPodCode.isRequire ? 'blue' : ''" :label="elementDict.secondPodCode.label" />
        <cargo-advance-select
          ref="secondPodCode"
          :disabled="!isEdit || !elementDict.secondPodCode.writable"
          no="secondPodCode"
          :select-type="selectTypeNames.basic_data_Airport"
          filterable
          :default-value="form.secondPodCode"
          tag-name="code"
          style="flex:1"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.secondPod.viewable" slot="secondPod" class="warn-label">
        <line-label slot="label" :class="elementDict.secondPod.isRequire ? 'blue' : ''" :label="elementDict.secondPod.label" />
        <el-input v-model="form.secondPod" disabled no="secondPod" />
      </el-form-item>
      <!-- 预计抵达中转时间 -->
      <el-form-item v-if="elementDict.estimatedTransferArrivalTime.viewable" slot="estimatedTransferArrivalTime" class="warn-label">
        <line-label slot="label" :class="elementDict.estimatedTransferArrivalTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedTransferArrivalTime.label" />
        <el-date-picker v-model="form.estimatedTransferArrivalTime" :disabled="!isEdit || !elementDict.estimatedTransferArrivalTime.writable" no="estimatedTransferArrivalTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
      </el-form-item>
      <!-- 抵达中转时间 -->
      <el-form-item v-if="elementDict.transferArrivalTime.viewable" slot="transferArrivalTime" class="warn-label">
        <line-label slot="label" :class="elementDict.transferArrivalTime.isRequire ? 'blue' : ''" :label="elementDict.transferArrivalTime.label" />
        <el-date-picker v-model="form.transferArrivalTime" :disabled="!isEdit || !elementDict.transferArrivalTime.writable" no="transferArrivalTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
      </el-form-item>
      <!-- 预计中转起飞时间 -->
      <el-form-item v-if="elementDict.estimatedTransferDepartureTime.viewable" slot="estimatedTransferDepartureTime" class="warn-label">
        <line-label slot="label" :class="elementDict.estimatedTransferDepartureTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedTransferDepartureTime.label" />
        <el-date-picker v-model="form.estimatedTransferDepartureTime" :disabled="!isEdit || !elementDict.estimatedTransferDepartureTime.writable" no="estimatedTransferDepartureTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
      </el-form-item>
      <!-- 中转起飞时间 -->
      <el-form-item v-if="elementDict.transferDepartureTime.viewable" slot="transferDepartureTime" class="warn-label">
        <line-label slot="label" :class="elementDict.transferDepartureTime.isRequire ? 'blue' : ''" :label="elementDict.transferDepartureTime.label" />
        <el-date-picker v-model="form.transferDepartureTime" :disabled="!isEdit || !elementDict.transferDepartureTime.writable" no="transferDepartureTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
      </el-form-item>
      <template v-if="elementDict.multiJourneyAirline && elementDict.multiJourneyAirline.viewable" slot="multiJourneyAirline">
        <el-button v-show="isEdit" size="mini" type="primary" style="float: right;margin-bottom: 5px;" @click="addAirline">{{ $t('SystemMaintenance.Add') }}</el-button>
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :show-side-bar="false"
          style="width:100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </template>
    </tab-vessel-eq-UICustom-layout>
    <generate-mbl-no-dialog
      :visible="mblConfig.visible"
      :form="form"
      :config="mblConfig"
      @close="mblConfig.visible =false"
    />
    <generate-so-no-dialog
      :visible="soNoConfig.visible"
      :form="form"
      :config="soNoConfig"
      :mbl-config="mblConfig"
      @close="soNoConfig.visible =false"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="advanceTextDialog.value" type="textarea" rows="10" />
      <span slot="footer">
        <el-button type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import tabVesselEqUICustomLayout from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabVesselEqUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabVesselEq from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabVesselEq'
import StrUtils from '@/utils/StrUtils'
import { handleBlur } from '@/utils/commonUtil'

export default {
  name: 'TabVesselEqUICustom',
  components: { tabVesselEqUICustomLayout },
  extends: tabVesselEq,
  props: { previewConfig: { type: Object, default: null }},
  data() {
    return {
      handleBlur,
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      }
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        UICustomUtil.handleViewAndWrite(UICustomConstants.AIR_BOOKING_VESSEL, this.elementDict, row)
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.AIR_BOOKING_VESSEL, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    validateForm() {
      const form = this.form
      for (const key in this.elementDict) {
        const element = this.elementDict[key]
        if (!element.viewable || !element.writable || !element.isRequire) {
          continue
        }
        if (!element.fieldNames) {
          continue
        }
        for (const fieldName of element.fieldNames) {
          const field = this.fieldDict[fieldName]
          if (typeof form[fieldName] !== 'boolean' && StrUtils.isEmpty(form[fieldName])) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabAirVesselEq')
          }
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return this.superFunction()
    }
  }
}
</script>

<style lang="scss" scoped>
  .tab-vessel-eq {
    /deep/ .el-submenu__title{
      border-bottom: none !important;
    }
    .warn-label .el-form-item__label{
      color: orange !important;
    }
    .mbl-red{
      .el-input__inner {
        color: red !important;
      }
    }
  }
</style>
